import type { FunctionComponent, ReactNode } from 'react';
import type { RadioProps } from '@mui/material/Radio';
import Radio from '@mui/material/Radio';
import type { FormControlLabelProps } from '@mui/material/FormControlLabel';
import FormControlLabel from '@mui/material/FormControlLabel';

type LabeledRadioProps = {
  label: ReactNode;
  value: string;
  isDisabled?: boolean;
  labelPlacement?: FormControlLabelProps['labelPlacement'];
  size?: RadioProps['size'];
};

/**
 * Wrapper for MaterialUI's <FormControlLabel /> + <Radio />
 * More aligned with the old RadioButton component API.
 * Should be used inside of a MUI.RadioGroup (which has an onChange handler)
 */
const LabeledRadio: FunctionComponent<LabeledRadioProps> = ({
  label,
  value,
  isDisabled,
  size,
  labelPlacement = 'end',
}) => (
  <FormControlLabel
    label={label}
    labelPlacement={labelPlacement}
    value={value}
    disabled={isDisabled}
    control={
      <Radio
        color="primary"
        size={size}
        disabled={isDisabled}
      />
    }
  />
);

export default LabeledRadio;
